/* eslint-disable jsx-a11y/alt-text */
import React, { PropsWithChildren } from 'react'

interface ImageViewProps extends PropsWithChildren<any> {
  src: string
  className?: string
  style?: any
  didLoad: () => void
  didFail: () => void
}

interface ImageViewState {
  done: boolean
}

interface ImageRef {
  readonly current: HTMLImageElement | null
}

export default class ImageView extends React.Component<ImageViewProps, ImageViewState> {
  imgRef: ImageRef

  constructor(props: ImageViewProps) {
    super(props)

    this.state = {
      done: false
    }

    this.imgRef = React.createRef()
  }

  componentDidUpdate(prevProps: ImageViewProps, _prevState: any) {
    if (this.props.className !== prevProps.className) {
      this.setState({ done: false }, () => {
        if (this.imgRef.current !== null && this.imgRef.current.complete) {
          this.handleLoad()
        }
      })
    }
  }

  handleLoad() {
    if (this.state.done) {
      return
    }

    this.setState({ done: true }, this.props.didLoad)
  }

  handleFail() {
    if (this.state.done) {
      return
    }

    this.setState({ done: true }, this.props.didFail)
  }

  render() {
    return (
      <img
        ref={this.imgRef}
        src={this.props.src}
        onLoad={() => this.handleLoad()}
        onError={() => this.handleFail()}
        className={this.props.className}
        style={this.props.style}
      />
    )
  }
}